import { TSearchDetail } from "@/redux/search/detail/types";

const initialState: TSearchDetail = {
  estates: null,
  data: null,
};

export default initialState;
